(() => {
  'use strict';
  const key='TMFooterInviteV59';
  if(window[key]){window[key].scan(document);return;}
  const instances=new Map();
  function init(section){
    if(instances.has(section))return;
    const details=section.querySelector('[data-tm-invite-details]');
    const trigger=section.querySelector('[data-tm-invite-open]');
    const panel=section.querySelector('[data-tm-invite-panel]');
    if(!details||!trigger||!panel)return;
    const probe=document.createElement('dialog');
    // Without native modal support, retain the complete inline details form.
    if(typeof probe.showModal!=='function')return;
    const dialog=probe;
    dialog.id='TmFooterInviteDialog-'+section.dataset.sectionId;
    dialog.className='tm-invite-v59__dialog';
    dialog.setAttribute('aria-labelledby','TmFooterInviteTitle-'+section.dataset.sectionId);
    dialog.setAttribute('aria-describedby','TmFooterInviteDescription-'+section.dataset.sectionId);
    dialog.append(panel);
    section.append(dialog);
    const closeButton=panel.querySelector('[data-tm-invite-close]');
    if(closeButton)closeButton.hidden=false;
    trigger.setAttribute('aria-haspopup','dialog');
    trigger.setAttribute('aria-controls',dialog.id);
    trigger.setAttribute('aria-expanded','false');
    let previousOverflow='',returnFocus=trigger,locked=false;
    function release(){
      if(locked){document.documentElement.style.overflow=previousOverflow;locked=false;}
      trigger.setAttribute('aria-expanded','false');
    }
    function open(opener){
      if(dialog.open)return;
      returnFocus=opener||trigger;
      try{dialog.showModal();}catch(error){
        // A blocked native dialog should still expose the original form.
        details.append(panel);details.open=true;
        if(closeButton)closeButton.hidden=true;
        trigger.removeEventListener('click',onTrigger);
        document.removeEventListener('click',onJoin);
        trigger.removeAttribute('aria-haspopup');trigger.removeAttribute('aria-controls');trigger.removeAttribute('aria-expanded');
        dialog.remove();
        return;
      }
      previousOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden';locked=true;
      trigger.setAttribute('aria-expanded','true');
      const focusTarget=panel.querySelector('[data-tm-form-feedback]')||panel.querySelector('input[type=email]');
      focusTarget?.focus({preventScroll:true});
    }
    function onTrigger(event){event.preventDefault();open(trigger);}
    function onClose(){release();if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});}
    function onBackdrop(event){
      if(event.target!==dialog)return;
      const bounds=dialog.getBoundingClientRect();
      if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
    }
    function onJoin(event){
      const link=event.target.closest?.('[data-tm-footer-join]');
      if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();open(link);
    }
    const onCloseButton=()=>dialog.close();
    trigger.addEventListener('click',onTrigger);
    dialog.addEventListener('close',onClose);
    dialog.addEventListener('click',onBackdrop);
    closeButton?.addEventListener('click',onCloseButton);
    document.addEventListener('click',onJoin);
    const instance={destroy(){
      trigger.removeEventListener('click',onTrigger);
      dialog.removeEventListener('close',onClose);
      dialog.removeEventListener('click',onBackdrop);
      closeButton?.removeEventListener('click',onCloseButton);
      document.removeEventListener('click',onJoin);
      if(dialog.open)dialog.close();
      release();details.append(panel);dialog.remove();
      if(closeButton)closeButton.hidden=true;
      trigger.removeAttribute('aria-haspopup');trigger.removeAttribute('aria-controls');trigger.removeAttribute('aria-expanded');
      instances.delete(section);
    }};
    instances.set(section,instance);
    // Shopify owns submission, anti-spam, validation and consent state. Reopen
    // the returned success/error response rather than hiding it in the dialog.
    if(panel.querySelector('[data-tm-form-feedback]'))open(trigger);
  }
  function scan(scope){
    if(scope.matches?.('[data-tm-footer-invite]'))init(scope);
    scope.querySelectorAll('[data-tm-footer-invite]').forEach(init);
  }
  window[key]={scan};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    for(const [section,instance] of instances)if(event.target===section||event.target.contains(section))instance.destroy();
  });
})();
